'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSpellcheck = function MdSpellcheck(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36 19.3l2.4 2.3-15.9 15.9-8.4-8.5 2.3-2.4 6.1 6.2z m-25.3-0.9h6.9l-3.5-9.3z m10.1 8.2l-2-5h-9.3l-1.9 5h-3.5l8.5-21.6h3.1l8.5 21.6h-3.4z' })
        )
    );
};

exports.default = MdSpellcheck;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/spellcheck.js
// module id = 1942
// module chunks = 168707334958949